/**
 * Single source of truth: which languages the UI actually offers and how they map to API `global.language`.
 * Extend `SUPPORTED_UI_LANGUAGE_CODES` and `UI_LANGUAGES` together when adding a locale.
 */
export const SUPPORTED_UI_LANGUAGE_CODES = ["de"] as const;

export type SupportedUiLanguageCode = (typeof SUPPORTED_UI_LANGUAGE_CODES)[number];

export const UI_LANGUAGES: ReadonlyArray<{
    code: SupportedUiLanguageCode;
    /** Shown in settings and anywhere else we list languages */
    label: string;
}> = [{ code: "de", label: "Deutsch" }];

export function isUiLanguageSupported(stored: string | undefined | null): boolean {
    return (
        stored != null &&
        (SUPPORTED_UI_LANGUAGE_CODES as readonly string[]).includes(stored)
    );
}

/**
 * Maps stored settings (may include legacy or not-yet-implemented codes) to a supported UI language.
 */
export function getEffectiveUiLanguage(stored: string | undefined | null): SupportedUiLanguageCode {
    if (isUiLanguageSupported(stored)) {
        return stored as SupportedUiLanguageCode;
    }
    return SUPPORTED_UI_LANGUAGE_CODES[0];
}
